import { useContext } from "react";

import { ContextStickers } from "./stickers.context";

export const useContextStickers = () => useContext(ContextStickers);
